import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { AuthService } from "../auth/authServices";
import { ConfigService } from "src/app/services/config.service";
@Injectable({
  providedIn: "root",
})
export class ReportsService {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private Auth: AuthService,
    private configService: ConfigService,
  ) {
    this.apiUrl = this.configService.get('apiUrl') + '/admin';
  }

  /** Resolved per request — role is not available when the service is first constructed. */
  private getRoleQuery(): string {
    const roleName = this.Auth.getRoleName();
    return roleName ? `&roleName=${encodeURIComponent(roleName)}` : "";
  }

  searchEncounterByCaseNumber(caseNumber: string) {
  const params = new HttpParams().set('caseNumber', caseNumber.trim());
  return this.http.get(`${this.apiUrl}/get_encounterCase`, { params });
}

  // getAllReports(
  //   filters: { [key: string]: string[] | string },
  //   page: number = 1,
  //   limit: number = 10,
  //    sortColumn: string = '',
  //   sortDirection: string = ''
  // ) {
  //   let params = new HttpParams()
  //     .set('page', page.toString())
  //     .set('limit', limit.toString());
    
  //   if (sortColumn && sortDirection) {
  //     params = params.set('sortColumn', sortColumn).set('sortDirection', sortDirection);
  //   }
    
  //     filters = filters || {};
  //     Object.keys(filters).forEach((key) => {
  //       const value = filters[key];
  
  //       if (Array.isArray(value)) {
  //         value.forEach((item) => {
  //           params = params.append(key, item);
  //         });
  //       } else if (typeof value === "string" && value.trim() !== "") {
  //         params = params.set(key, value.trim());
  //       }
  //     });
  
  //   return this.http.get(`${this.apiUrl}/get_all_reports`, { params });
  // }
    getAllReports(
  filters: { [key: string]: string[] | string },
  page: number = 1,
  limit: number = 10,
  sortColumn: string = '',
  sortDirection: string = ''
) {
  let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
  
  if (sortColumn && sortDirection) {
    params = params.set('sortColumn', sortColumn).set('sortDirection', sortDirection);
  }
  
  filters = filters || {};
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        params = params.append(key, item);
      });
    } else if (typeof value === "string" && value.trim() !== "") {
      params = params.set(key, value.trim());
    }
  });

  return this.http.get(`${this.apiUrl}/get_all_reports`, { params });
}
getHistoryQueue(
  filters: string[],
  page: number,
  limit: number,
  sortField: string,
  sortOrder: string,
  countOnly = false
): Observable<any> {
  let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
  if (countOnly) {
    params = params.set('countOnly', 'true');
  }
  if (sortField && sortOrder) {
    params = params.set('sortField', sortField).set('sortOrder', sortOrder);
  }
  if (filters.length) {
    params = params.append('types', filters.join(','));
  } else {
    params = params.append('types', 'History');
  }
  return this.http.get(`${this.apiUrl}/queue/history`, { params });
}

getRecordQueue(
  filters: string[],
  page: number,
  limit: number,
  sortField: string,
  sortOrder: string,
  countOnly = false
): Observable<any> {
  let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
  if (countOnly) {
    params = params.set('countOnly', 'true');
  }
  if (sortField && sortOrder) {
    params = params.set('sortField', sortField).set('sortOrder', sortOrder);
  }
  if (filters.length) {
    params = params.append('types', filters.join(','));
  } else {
    params = params.append('types', 'Record Review');
  }
  return this.http.get(`${this.apiUrl}/queue/record`, { params });
}


getFinalizationQueue(
  filters: string[],
  page: number,
  limit: number,
  sortField: string,
  sortOrder: string,
  countOnly = false
): Observable<any> {
  let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
  if (countOnly) {
    params = params.set('countOnly', 'true');
  }
  if (sortField && sortOrder) {
    params = params.set('sortField', sortField).set('sortOrder', sortOrder);
  }
  if (filters.length) {
    params = params.append('types', filters.join(','));
  } else {
    params = params.append('types', 'Finalize Report');
  }
  return this.http.get(`${this.apiUrl}/queue/finalization`, { params });
}

  fetchTaskList(
    endpoint: string,
    filters: Record<string, string> = {},
    skip = 0,
    limit = 20,
    countOnly = false
  ): Observable<{ status: string; data?: any[]; count?: number }> {
    let params = new HttpParams()
      .set("skip", String(skip))
      .set("limit", String(limit));
    if (countOnly) {
      params = params.set("countOnly", "true");
    }
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<{ status: string; data?: any[]; count?: number }>(
      `${this.apiUrl}/${endpoint}`,
      { params }
    );
  }

  fetchTaskListCounts(
    filters: Record<string, string> = {}
  ): Observable<{ status: string; counts?: Record<string, number> }> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<{ status: string; counts?: Record<string, number> }>(
      `${this.apiUrl}/task-list-counts`,
      { params }
    );
  }

  getPatientProfile_2(id: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/get_patient_detail/${id}`, {});
  }
  getPatientEncounter(id: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/get_patient_from_encounter/${id}`, {});
  }

  updatePatientProfile(id: string, applicantData: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/update_patient_detail/${id}?name=Update Applicant Profile${this.getRoleQuery()}`,
      { applicantData }
    );
  }

updateHistoryDriveLink(id: string, history_driveLink: string): Observable<any> {
  return this.http.post<any>(
    `${this.apiUrl}/update-history-drive/${id}`,
    { history_driveLink }
  );
}

  assignTask(id: string, assignId: any, type: any, occurrenceId?: string | null): Observable<any> {
    const body: Record<string, unknown> = { assignId, type };
    if (occurrenceId) {
      body.occurrenceId = occurrenceId;
    }
    return this.http.post<any>(
      `${this.apiUrl}/assign_task/${id}?name=Assign tasks${this.getRoleQuery()}`,
      body
    );
  }

  deleteFile(encounterId: string, fileId: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/delete_file/${encounterId}/${fileId}`,
      {}
    );
  }

  updateFileName(
    encounterId: string,
    fileId: string,
    newName: string
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/update_file_name/${encounterId}/${fileId}`,
      { newName }
    );
  }

  createPreviousEncounter(
    data: any,
    applicantID: string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      this.apiUrl + "/create_previous_encounter/" + applicantID,
      data
    );
  }

  updatePreviousEncounter(
    data: any, 
    applicantID: string, 
    encounterId: string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      `${this.apiUrl}/update_previous_encounter/${applicantID}/encounter/${encounterId}`,
      data
    );
  }

  deletePreviousEncounterDoc(
    applicantID: string, 
    encounterId: string,
    docId:string
  ): Observable<{ message: string; data: any }> {
    return this.http.post<{ message: string; data: any }>(
      `${this.apiUrl}/applicants/${applicantID}/encounters/${encounterId}/documents/${docId}`,
      {}
    );
  }
}
